<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>Patient IDs</v-toolbar-title>
            <v-spacer/>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Patient ID"
                    single-line
                    hide-details
                    clearable
                    @click:clear="handleClearSearch"
                    v-debounce:300="handleSearch">
            </v-text-field>
            <v-spacer/>
            <v-text-field
                v-model="uId"
                single-line
                clearable
                label="User ID"
                @click:clear="handleClearuId"
                v-debounce:300="handleSearch">
            </v-text-field>
            <v-spacer/>
            <v-text-field
                v-model="orgId"
                single-line
                clearable
                label="Org ID"
                @click:clear="handleClearOrgId"
                v-debounce:300="handleSearch">
            </v-text-field>
            <v-spacer/>
            <v-icon large class="mr-2" @click="loadItems">
                mdi-refresh
            </v-icon>
            <TrendingDialog :dialog="trendingDialog" @dialog-close="trendingDialogClose"/>
        </v-toolbar>
        <v-container fluid>
            <v-row no-gutters>
                <v-col>
                    <v-data-table
                        :headers="headers"
                        :items="mrns"
                        item-key="id"
                        @click:row="rowSelected"
                        :expanded.sync="expanded"
                        :options.sync="pagination"
                        :server-items-length="totalRecords"
                        :single-expand=true
                        :loading="waiting"
                        :footer-props="{'items-per-page-options':[15, 30, 50, 100]}"
                        class="elevation-1"
                        @update:options="loadItems">
                        <template v-slot:item.expanded="{ item }">
                            <v-row justify-Left>
                                <v-icon large v-if="!expanded.includes(item)">mdi-chevron-right</v-icon>
                                <v-icon large v-else>mdi-chevron-down</v-icon>
                            </v-row>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-row>
                                <v-icon class="mr-3" small>
                                </v-icon>
                                <template>
                                    <v-tooltip bottom color="black" open-delay="800" :disabled=tipDisabling.trending>
                                        <template #activator="{ on }">
                                        <span v-on="on">
                                            <v-icon class="mr-2" small @click="trending(item)">
                                                mdi-chart-line
                                            </v-icon>
                                        </span>
                                        </template>
                                        <span>Trending</span>
                                    </v-tooltip>
                                </template>
                            </v-row>
                        </template>
                        <template v-slot:expanded-item="props">
                            <td :colspan=12>
                                <v-expand-transition>
                                    <v-card class="elevation-10">
                                        <v-card-text>
                                            <ListMrnTests :mrnPredicate="mrnPredicate"/>
                                        </v-card-text>
                                    </v-card>
                                </v-expand-transition>
                            </td>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        <ConfirmationDialog v-if="confirmDeleteMrn" :params="confirmDeleteMrnParams" @confirmation-dialog-response="confirmDeleteMrnHandler"></ConfirmationDialog>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import ListMrnTests from '@/components/list-mrn-tests'
    import TrendingDialog from '@/components/trending-dialog'
    import ConfirmationDialog from '@/components/confirmation-dialog'

    export default
    {
        name: 'research-tests',
        components:
        {
            ListMrnTests,
            TrendingDialog,
            ConfirmationDialog
        },
        data: function ()
        {
            return {
                tipDisabling:
                {
                    trending: false
                },
                mrnPredicate: {},
                expandOrHideRow: true,
                expanded: [],
                pagination: {},
                search: '',
                uId: '',
                orgId: '',
                headers:
                [
                    {
                        text: 'Tests',
                        value: 'expanded',
                        width: '40px',
                        sortable: false
                    },
                    {
                        text: 'Patient ID',
                        value: 'mrn',
                        width: '240px',
                        sortable: false
                    },
                    {
                        text: 'Name',
                        value: 'name',
                        width: '240px',
                        sortable: false
                    },
                    {
                        text: 'Age',
                        value: 'age',
                        width: '40px',
                        sortable: false
                    },
                    {
                        text: 'Last Test Administrator',
                        value: 'displayName',
                        width: '240px',
                        sortable: false
                    },
                    {
                        text: 'Last Activity Date',
                        value: 'updatedAt',
                        width: '225px',
                        sortable: false
                    },
                    {
                        text: 'Actions',
                        value: 'actions',
                        sortable: false
                    }
                ],
                trendingDialog: false,
                confirmDeleteMrn: false,
                confirmDeleteMrnParams:
                {
                    title: 'Delete Patient ID',
                    text: '',
                    positiveResponse: 'Yes',
                    negativeResponse: 'No',
                    context: ''
                }
            }
        },
        destroyed()
        {
            this.CLEAR_TESTS()
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser
            }),
            ...mapState('mrns',
            {
                mrns: state => state.mrns,
                totalRecords: state => state.totalRecords
            }),
            ...mapState('tests',
            {
                tests: state => state.tests
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        watch:
        {
            search()
            {
                this.pagination.page = 1
            },
            uId()
            {
                this.pagination.page = 1
            },
            orgId()
            {
                this.pagination.page = 1
            }
        },
        methods:
        {
            ...mapActions('mrns', ['GET_MRNS', 'DELETE_MRN']),
            ...mapMutations('tests', ['CLEAR_TESTS']),
            ...mapActions('tests', ['GET_TESTS']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            async handleSearch()
            {
                await this.loadItems()
            },
            async handleClearSearch()
            {
                this.search = '';
                await this.loadItems()
            },
            async handleClearuId()
            {
                this.uId = '';
                await this.loadItems()
            },
            async handleClearOrgId()
            {
                this.orgId = '';
                await this.loadItems()
            },
            rowSelected(item)
            {
                // Do not expand or hide the row if an action in a row was selected
                if (!this.expandOrHideRow)
                {
                    this.expandOrHideRow = true
                }
                else
                {
                    this.expanded = this.expanded.length > 0 && this.expanded[0].id === item.id ? [] : [item]
                }
                if (!this.trendingMrn)
                {
                    this.mrnPredicate = {mrn: item.mrn, uId: item.createdBy}
                }
            },
            async loadItems()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.GET_MRNS({pagination: this.pagination, search: this.search, researchMode: true, uId: this.uId, orgId: this.orgId})
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message);
                }
                this.WAITING(false)
            },
            async deleteItem(item)
            {
                this.expandOrHideRow = false;
                this.confirmDeleteMrnParams.text = `Are you sure you want to delete Patient ID: ${item.mrn}?`;
                this.confirmDeleteMrnParams.context = item;
                this.confirmDeleteMrn = true
            },
            async confirmDeleteMrnHandler(payload)
            {
                this.confirmDeleteMrn = false;
                // If the MRN should be deleted
                if (payload.response)
                {
                    try
                    {
                        this.HIDE_SNACKBAR();
                        this.WAITING(true);
                        await this.DELETE_MRN({mrn: payload.context.mrn});
                        this.mrnPredicate = {};
                        this.loadItems()
                    }
                    catch (error)
                    {
                        this.SHOW_SNACKBAR_ERROR(error.message);
                    }
                    this.WAITING(false)
                }
            },
            async trending(item)
            {
                this.tipDisabling.trending = true;
                this.shouldCollapse(item);
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.GET_TESTS({mrn: item.mrn, uId: item.createdBy});
                    this.trendingDialog = true
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            },
            trendingDialogClose()
            {
                this.trendingDialog = false
            },
            shouldCollapse(item)
            {
                this.expandOrHideRow = false;
                // Collapse the row if switching to a new row
                if (this.expanded.length === 1 && this.expanded[0].mrn !== item.mrn)
                {
                    this.expanded = []
                }
            }
        }
    }

</script>

<style scoped>
</style>